<template>
  <rt-button :loading="loading" :disabled="disabled" @click="handleClick">
    {{ $tx(buttonText, buttonTextCode || buttonTextEnglish) }}
  </rt-button>
</template>

<script>
export default {
  name: "RtSoButton",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonTextEnglish: {
      type: String,
      default: null,
    },
    textType: {
      type: String,
    },
  },
  data() {
    return {
      iconClass: null,
      buttonText: null,
      buttonTextCode: null,
    };
  },
  created() {
    switch (this.textType) {
      case "add":
        this.buttonText = this.text || "新建";
        this.buttonTextCode = "common.add";
        break;
      case "print":
        this.buttonText = this.text || "打印";
        this.buttonTextCode = "common.print";
        break;
      case "confirm":
        this.buttonText = this.text || "确认";
        this.buttonTextCode = "common.confirm";
        break;
      case "approve-progress":
        this.buttonText = this.text || "审批进度";
        this.buttonTextCode = "order.approvalPprogress";
        break;
      case "delete":
        this.buttonText = this.text || "删除";
        this.buttonTextCode = "common.delete";
        break;
      case "enable":
        this.buttonText = this.text || "启用";
        this.buttonTextCode = "common.enable";
        break;
      case "disable":
        this.buttonText = this.text || "停用";
        this.buttonTextCode = "common.disable";
        break;
      case "more":
        this.buttonText = this.text || "更多";
        this.buttonTextCode = "common.more";
        break;
      case "export":
        this.buttonText = this.text || "导出";
        this.buttonTextCode = "common.export";
        break;
      case "import":
        this.buttonText = this.text || "导入";
        this.buttonTextCode = "common.import";
        break;
      case "submit":
        this.buttonText = this.text || "提交";
        this.buttonTextCode = "common.submit";
        break;
      case "revert":
        this.buttonText = this.text || "撤回";
        this.buttonTextCode = "common.recall";
        break;
      case "download":
        this.buttonText = this.text || "下载";
        this.buttonTextCode = "common.downloadBtn";
        break;
      case "upload":
        this.buttonText = this.text || "上传";
        this.buttonTextCode = "tempcredit.upload";
        break;
      case "save":
        this.buttonText = this.text || "保存";
        this.buttonTextCode = "common.save";
        break;
      case "active":
        this.buttonText = this.text || "激活";
        this.buttonTextCode = "common.activate";
        break;
      case "revision":
        this.buttonText = this.text || "修订";
        this.buttonTextCode = "quote.revision";
        break;
      default:
        this.buttonText = this.text || "<Text>";
        break;
    }
  },
  mounted() {},
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>


// WEBPACK FOOTER //
// main.vue?c9e15d80